import AxiosInstance from "./axiosInstance";

export const listAllOrders = () => {
  return AxiosInstance.get("/purchase-order")
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};

export const getOrder = (id) => {
  return AxiosInstance.get(`/purchase-order/${id}`)
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
export const exportPurchaseOrder = (id) => {
  return AxiosInstance.get(`/purchase-order/${id}/export`)
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
export const importSalesOrderData = (id, files) => {
  const formData = new FormData();
  formData.append("import", files);
  return AxiosInstance.patch(`/purchase-order/${id}/import`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
export const updateOrders = (id, data) => {
  return AxiosInstance.patch(`/purchase-order/${id}`, data)
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
export const deleteOrders = (id) => {
  return AxiosInstance.delete(`/purchase-order/${id}`)
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
